export const styles = {
  dialogContent: {
    width: '480px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  textField: {
    mt: '20px',
    width: '100%',
  },
  footer: {
    mt: '37px',
    justifyContent: 'space-between',
  },
  switchTextContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  switchIcon: {
    width: '20px',
    height: '20px',
    ml: '6px',
    color: 'text.secondary',
  },
  switchActiveIcon: {
    width: '20px',
    height: '20px',
    ml: '6px',
    color: 'primary.main',
  },
  privacySection: {
    mt: '24px',
  },
  privacySelector: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    px: 1.5,
    py: 0.75,
    borderRadius: 999,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'divider',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'primary.main',
    },
  },
  privacySelectorLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  privacyCardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
    p: 2,
    backgroundColor: 'background.paper',
  },
  privacyCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    px: 0,
    py: 0.5,
  },
  privacyCardSelected: {
    // reserved for potential future selected styling
  },
  privacyCardIcon: {
    mr: 1.5,
    mt: 0.25,
  },
  privacyCardTitles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  privacyCardTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  privacyCardSubtitle: {
    color: 'text.secondary',
  },
  sharedPanel: {
    mt: 1.5,
    p: 0,
    width: '100%',
  },
  sharedPanelHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    mb: 1,
  },
  sharedSearchField: {
    mb: 1,
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 1.5,
      '& fieldset': {
        borderColor: 'primary.main',
        borderWidth: 2,
      },
      '&:hover fieldset': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
      },
    },
  },
  sharedList: {
    maxHeight: 200,
    overflowY: 'auto',
    mt: 0.5,
    width: '100%',
  },
  sharedListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    py: 0.75,
    cursor: 'pointer',
  },
  optionCheckSlot: {
    width: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mr: 1,
  },
  sharedListItemLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};
